import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const city = {
  path: '/printHistory',
  component: Layout,
  name: 'printHistory',
  redirect: '/printHistory/index',
  children: [{
    path: '/printHistory/index',
    component: () => import('@/views/printHistory/index'),
    name: 'printHistory.index',
    meta: {
      title: i18n.t(`message.print_hitory`)
    }
  }, ]
}

export default city